const state = {
  // 人员
  searchPerApproval: null,
  searchPerAppliceApproval: null,
  searchPerAppliceHistory: null,
  searchAllPerAppliceHistory: null,
  // 车辆
  searchCarEnterApplice: null,
  searchCarAppliceApproval: null,
  searchCarAppliceHistory: null,
  searchAllCarAppliceHistory: null,
  searchCarRegistration: null,
  searchCarRegApproval: null,
  searchCarRegHistory: null,
  searchCarMark: null,
  // 设备管理
  searchEquipCarFace: null,
  searchEquipSecurity: null,
  searchEquipCarScale: null,
  searchEquipGate: null,
  searchEquipBuried: null,
  searchEquipBumping: null,
  // 黑白名单
  searchBlackCar: null,
  searchBlackCarApproval: null,
  searchBlackPerson: null,
  searchBlackPersonApproval: null,
  // 过闸记录
  searchGateVehicle: null,
  searchGatePerson: null,
}

const mutations = {
  setPerApproval(state, params) {
    state.searchPerApproval = params
  },
  setPerAppliceApproval(state, params) {
    state.searchPerAppliceApproval = params
  },
  setPerAppliceHistory(state, params) {
    state.searchPerAppliceHistory = params
  },
  setAllPerAppliceHistory(state, params) {
    state.searchAllPerAppliceHistory = params
  },
  setCarEnterApplice(state, params) {
    state.searchCarEnterApplice = params
  },
  setCarAppliceApproval(state, params) {
    state.searchCarAppliceApproval = params
  },
  setCarAppliceHistory(state, params) {
    state.searchCarAppliceHistory = params
  },
  setAllCarAppliceHistory(state, params) {
    state.searchAllCarAppliceHistory = params
  },
  setCarRegistration(state, params) {
    state.searchCarRegistration = params
  },
  setCarRegApproval(state, params) {
    state.searchCarRegApproval = params
  },
  setCarRegHistory(state, params) {
    state.searchCarRegHistory = params
  },
  setCarMark(state, params) {
    state.searchCarMark = params
  },
  setEquipCarFace(state, params) {
    state.searchEquipCarFace = params
  },
  setEquipSecurity(state, params) {
    state.searchEquipSecurity = params
  },
  setEquipCarScale(state, params) {
    state.searchEquipCarScale = params
  },
  setEquipGate(state, params) {
    state.searchEquipGate = params
  },
  setEquipBuried(state, params) {
    state.searchEquipBuried = params
  },
  setEquipBumping(state, params) {
    state.searchEquipBumping = params
  },
  setBlackCar(state, params) {
    state.searchBlackCar = params
  },
  setBlackCarApproval(state, params) {
    state.searchBlackCarApproval = params
  },
  setBlackPerson(state, params) {
    state.searchBlackPerson = params
  },
  setBlackPersonApproval(state, params) {
    state.searchBlackPersonApproval = params  
  },
  setGateVehicle(state, params) {
    state.searchGateVehicle = params
  },
  setGatePerson(state, params) {
    state.searchGatePerson = params
  },
}

export default {
  namespaced: true,
  state,
  mutations
}